// extracted by css-extract-rspack-plugin
export default {"componentTabHeaderContainer":"src-wab-client-components-sidebar-tabs-ComponentTab-ComponentTab-module__componentTabHeaderContainer-oyV_XT"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"componentTabHeaderContainer\":\"src-wab-client-components-sidebar-tabs-ComponentTab-ComponentTab-module__componentTabHeaderContainer-oyV_XT\"}";
        // 1793541991277
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  